import classes from './ChatActions.module.css'
import { ReactComponent as ShareSVG } from '../../../../assests/chat/bina-share.svg';
import { ReactComponent as ReportSVG } from '../../../../assests/chat/bina-report.svg';
import { ReactComponent as NewSVG } from '../../../../assests/chat/bina-new-conversation.svg';
import { ReactComponent as ShareDarkSVG } from '../../../../assests/chat/bina-share-dark.svg';
import { ReactComponent as ReportDarkSVG } from '../../../../assests/chat/bina-report-dark.svg';
import { ReactComponent as NewDarkSVG } from '../../../../assests/chat/bina-new-conversation-dark.svg';
import { useSelector } from 'react-redux';



function ChatActions(props) {
    const generalState = useSelector(state => state.general)
    const { texts } = useSelector(state => state.translate);

    let reportSVG = <ReportSVG/>
    let shareSVG = <ShareSVG/>
    let newSVG = <NewSVG/>
    if (generalState.themeColor === "dark") {
        reportSVG = <ReportDarkSVG/>
        shareSVG = <ShareDarkSVG/>
        newSVG = <NewDarkSVG/>
    }
    return (
        <div className={classes.ChatActions}>
            <div className={classes.ActionsContainer}>
                {/* <button className={classes.ActionButton} onClick={props.onReport}>
                    {texts.report}
                    {reportSVG}
                </button> */}
                <button alt={texts.newConversation} className={classes.ActionButton} onClick={props.onRefresh}>
                    {texts.newConversation}
                    {newSVG}
                </button>
                <button alt={texts.share} className={classes.ActionButton} onClick={props.onShare}>
                    {texts.share}
                    {shareSVG}
                </button>
            </div>
        </div>
    );
}

export default ChatActions;